module.exports = __webpack_public_path__ + "img/icon-16.ffd1d94b.png";